<script>
import InvoiceList from '../../components/invoice/InvoiceList.vue'

export default {
  components: {
    InvoiceList
  },
}
</script>


<template>
  <InvoiceList
      endpoint="/invoice/deleted"
  />
</template>
